export enum TagSize {
	Regular = 'regular',
	Small = 'small',
}
export enum TagSeverity {
	Info = 'info',
	Success = 'success',
	Failure = 'failure',
	Attention = 'attention',
}
